angular.module('tasks', ['dndLists', 'mentio'])
.constant('TASK_TYPE_FILTER', [
  {caption: 'View All',value:''},
  {caption: 'Weekly Reporting',value:'weeklyreporting'},
  {caption: 'Monthly Reporting',value:'periodreporting'},
  // {caption: 'Transaction Support',value:'transactionsupport'}
]);
//CONST_TASK_STATUS_NEEDS_SUPPORT = 0;
//CONST_TASK_STATUS_NEEDS_PROCESSING = 1;
//CONST_TASK_STATUS_BEING_PROCESSED = 2;
//CONST_TASK_STATUS_NEEDS_REVIEW = 3;
//CONST_TASK_STATUS_DONE = 4;



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/taskManagement/_module.js